module.exports = __webpack_public_path__ + "media/assets/images/flags/sn-1ffa1caabe88ac49f624d4a99f300c00.svg";